<template>
  <tile-basic
    class="is-info"
    :title="action.name"
    img="action"
    imgSize="75px"
    headerImg="action"
    :link="actionLink"
    :values="keyValues(action)">
  </tile-basic>
</template>

<script>
import mixin from '@/mixins/actions';
import TileBasic from '@/components/TileBasic.vue';

export default {
  name: 'TileAction',
  mixins: [mixin],
  components: {
    TileBasic,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
    link: {
      default: null,
    },
  },
  computed: {
    actionLink() {
      if (this.link === null) {
        return this.generateLink(this.action);
      }
      return this.link;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
